<template>
    <div class="pa-t-40 bg-round bg-fff">
        <div class="container pa-b-30">
            <Bread/>
        </div>
        
        
        <div class="container line-height-35 main-md vhtml">
            <div v-html="detail.Content"></div>
        </div>

        <div  class="img-a-bg" v-if="detail.Content">
            <img src="../../img/merge/i2.png" alt="" srcset="" class="img-logo c-pointer">
        </div>

    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";

   .img-person {
        width: 220px;
    }
    @media (min-width: 768px) {
        .header-li {
            // margin-right: 40px;
        }
        .main-md{
            margin: 0 auto;
            width: 680px;
        }
    }
    

    .img-a-bg {
        width: 100%;
        height: 285px;
        background: url('../../img/merge/cp11.png') no-repeat;
        background-size: cover;
        background-position: center center;
        text-align: right;
        line-height: 285px;
    }

    .img-logo {
        width: 206px;
        height: 206px;
        margin-right: 40px;
    }
    .vhtml img{max-width: 100%;}
    
    @media (max-width:768px) {
        .img-a-bg{
            display:none;
        }
    }
</style>
<script>
    import {getOther} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                detail:"",
                Content:"",
                footbottom:123,
            };
        },
        created() {
            console.log("开始开发")
            this.getDetail();
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            getDetail() {
                let data = {
                    code: "competition.haiPai",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                    // this.Content=res.data.Data.Content.replace(/<img/g,"<img mode='widthFix' style='width: 100%;vertical-align: middle;height: auto;'");
                });
            },
            toPage(url){
                this.$router.push(url);
            }
        },
    };
</script>
